export function danfeFilename(blob: Blob, reference: string): string {
  const extension = blob.type.includes("pdf") ? "pdf" : "html";
  return `nfce-${reference}.${extension}`;
}
